import type { ReactNode } from 'react'

/** Renders the `backtick` spans of a static string as `<code>`. */
export function renderInlineCode(text: string): ReactNode[] {
  return text.split('`').map((part, index) =>
    index % 2 === 1 ? (
      <code
        key={index}
        className="bg-surface-medium rounded-xs px-1 font-mono text-[0.9em]"
      >
        {part}
      </code>
    ) : (
      part
    ),
  )
}
